import { DISPOSITIONS, IDispositionItemConfig } from "config/dispositions";
import { EApiDispositionId } from "utils/offer/types";

const getQueryValues = (
  disp: Array<EApiDispositionId>,
): Array<IDispositionItemConfig> => {
  const disps = disp.map((d) =>
    DISPOSITIONS.find((dd) => dd.apiIds.includes(d as EApiDispositionId)),
  );

  return disps.filter(Boolean) as Array<IDispositionItemConfig>;
};

export default getQueryValues;
